export enum AlertTypeEnum{
  creation =  'creation',
  confirmation = 'confirmation',
  rejection = 'rejection'
}
